import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Measure before you manage.",
    body: "We start with honest data — your sleep, your spending, your stress. Clarity is the first medicine.",
  },
  {
    n: "02",
    title: "Small systems beat big willpower.",
    body: "Lasting change is engineered, not forced. We design tiny daily protocols that compound.",
  },
  {
    n: "03",
    title: "Treat the whole person.",
    body: "Your body, wealth, mind and relationships are one system. We never fix one by neglecting another.",
  },
  {
    n: "04",
    title: "Progress you can feel.",
    body: "Every month you leave with something tangible — more energy, more margin, more peace.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" className="relative py-24 lg:py-40 border-y border-brand-line bg-brand-surface2/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <span className="overline">The manifesto</span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-brand-text mt-4 mb-20 max-w-3xl">
          How we work together.
        </h2>

        <div className="space-y-2">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-${c.n}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
              className="group relative grid md:grid-cols-12 gap-6 items-center py-10 border-t border-brand-line"
            >
              <div className="md:col-span-3">
                <span className="font-serif text-7xl lg:text-8xl text-brand-text/10 group-hover:text-brand-gold/30 transition-colors duration-500">
                  {c.n}
                </span>
              </div>
              <h3 className="md:col-span-5 font-serif text-3xl lg:text-4xl text-brand-text">
                {c.title}
              </h3>
              <p className="md:col-span-4 text-brand-dim leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
